export default "__VITE_ASSET__CIksvxL8__"